export interface TransferDateOptions {
  dates: string[];
  minimumWorkDays: number;
  maximumCalendarDays: number;
}

export interface TransferDatesResponse {
  withSimMailing: {
    dates: string[];
    minimumWorkDays: number;
    maximumCalendarDays: number;
  },
  withoutSimMailing: {
    dates: string[];
    minimumWorkDays: number;
    maximumCalendarDays: number;
  }
}

export class MnpTransferDateService {
  getTransferDates(data: TransferDatesResponse): TransferDateOptions {
    const withSimMailing = data.withSimMailing;
    const withoutSimMailing = data.withoutSimMailing;

    return {
      dates: withoutSimMailing.dates,
      minimumWorkDays: withSimMailing.minimumWorkDays,
      maximumCalendarDays: withSimMailing.maximumCalendarDays,
    };
  }

  getUTCDate(date: string): Date {
    const dateObj = new Date(date);
    const dateUTC = new Date(dateObj.getTime() + dateObj.getTimezoneOffset() * 60000);
    return new Date(dateUTC);
  }

  getISOStringFromDate(date: Date): string {
    const utcDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
    return utcDate.toISOString();
  }

  getDateFromISOString(date: string): Date {
    return new Date(date);
  }
}

export const mnpTransferDateService = new MnpTransferDateService();
